import User from '@/classes/users/User'
import axios from '@/vendors/axios/axios'

const endpoint = '/auth'
const resource = 'auth'

export default {
  namespaced: true,
  state: {
    user: null
  },
  getters: {
    user: state => state.user,
    isAuthenticated: state => !!state.user
  },
  actions: {
    fetchAuthUser ({ state, commit }) {
      return new Promise((resolve, reject) => {
        axios.get(`${endpoint}/user`)
          .then(response => {
            const user = new User(response.data.data)
            commit('setItem', { resource, id: 'user', item: user }, { root: true })

            trackSessionStarted({ user })
            trackUser({ user })

            resolve(state.user)
          })
          .catch(error => reject(error))
      })
    },

    fetchAuthUserTransactions: ({ dispatch }) => dispatch(
      'fetchItem',
      { endpoint: `${endpoint}/user/transactions` },
      { root: true }
    ),

    patchAuthUser: ({ dispatch }, { params }) => dispatch(
      'patchItem',
      {
        endpoint: `${endpoint}/user`,
        resource,
        id: 'user',
        params: {
          user: params
        },
        model: user => new User(user)
      },
      { root: true }
    ),

    patchAuthUserImage: ({ dispatch }, { params }) => dispatch(
      'patchImage',
      {
        endpoint: `${endpoint}/user`,
        resource,
        id: 'user',
        params
      },
      { root: true }
    )
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    }
  }
}
